// extracted by mini-css-extract-plugin
export default {"appWrapper":"app_appWrapper__q+ED5","app":"app_app__38jf2"};